import { render } from "./menu-list.vue?vue&type=template&id=55901446&scoped=true&ts=true"
import script from "./menu-list.vue?vue&type=script&lang=ts"
export * from "./menu-list.vue?vue&type=script&lang=ts"

import "./menu-list.vue?vue&type=style&index=0&id=55901446&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\v3-admin-all\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55901446"]])

export default __exports__